import React, {PureComponent} from 'react';
import {AspectRatioCard} from '@homeaway/react-aspect-ratio-card';
import LazyLoad from '../lazy-image/react-lazyload/index';
import {LAZY_LOAD_OFFSET} from '../../../utils/constants';
import PriceLabel from './PriceLabel';

function imageLoaded() {
}

function placeholderImage(altText) {
    return (
        <div
            className="placeholder"
            alt={altText}
        />
    );
}

export class RatioCard extends PureComponent {
    render() {
        const {
            altText,
            aspectRatio = '3x4',
            footer,
            getImageUrl,
            horizontalScrollContainer = '',
            isMobile,
            linkRel,
            onClick,
            path,
            priceLabel,
            title
        } = this.props;

        const link = {
            href: path,
            rel: linkRel
        };

        const imageUri = getImageUrl('xs');

        const placeholder = placeholderImage('');
        const priceLabelComponent = priceLabel ? <PriceLabel text={priceLabel.price} /> : null;
        const offset = LAZY_LOAD_OFFSET[isMobile ? 'MOBILE' : 'DEFAULT'];

        const cardComponent = (
            <a {...link} onClick={onClick} className="RatioCard RatioCard__priceLabel" title={title}>
                <AspectRatioCard aspectRatio={aspectRatio} key={imageUri} async>
                    <div data-slot={'figure'} className="RatioCard__img-container" onLoad={imageLoaded}>
                        <LazyLoad once offset={offset} placeholder={placeholder} addListener={horizontalScrollContainer}>
                            <img src={imageUri} alt={altText}/>
                        </LazyLoad>
                    </div>
                    <div data-slot={'caption'} className="RatioCard__caption">
                        {priceLabelComponent}
                    </div>
                    <div data-slot={'content'} className="RatioCard__content">
                        <h4>{title}</h4>
                        <div>{footer}</div>
                    </div>
                </AspectRatioCard>
            </a>
        );

        return cardComponent;
    }
}
